import React from 'react'
import PropTypes from 'prop-types'
import EventTicketHeader from 'components/EventTicketHeader'
import PrimaryButton from 'components/PrimaryButton'
import { OVERLAY } from 'components/AuthModal/styles'
import Overlay from 'components/AuthModal/components/Overlay'
import Modal from 'components/AuthModal/components/Modal'

const NewTicketModal = ({ event, show, onClose, onEnterEvent }) => {
  if (!event) {
    return null
  }

  return (
    <Overlay show={show} className={OVERLAY} autoFocus={false} onClose={onClose}>
      <Modal outerClassName="bg-transparent">
        <div className="mx-4 text-white md:w-108">
          <EventTicketHeader event={event} />
          <div className="relative w-full flex flex-col items-center text-center bg-ashBlack rounded-xl px-4 py-8 md:px-14 md:py-16">
            <div className="text-2xl font-ownersWide mb-5 md:text-3xl">Your ticket is reserved</div>
            <div className="opacity-50 text-base mb-10 md:w-72">
              Let’s get your setup in advance so you’re ready for the event.
            </div>
            <PrimaryButton className="text-base h-14 w-full md:w-48" onClick={onEnterEvent}>
              Get Set Up
            </PrimaryButton>
          </div>
        </div>
      </Modal>
    </Overlay>
  )
}

NewTicketModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onEnterEvent: PropTypes.func,
  event: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    status: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
  }),
}

export default NewTicketModal
